module.exports = __webpack_public_path__ + "img/preferences.48da1031.png";